export default function docRequiredIssuingAuthority(entity) {
  let isValid = true,
    helpTextTranslationIndex = 'doc_issuing_authority_required',
    fields = [];

  if (!entity.getIssuingAuthority()) {
    isValid = false;
    fields = [{ name: 'issuingAuthority', fieldTree: [] }];
  }

  return {
    valid: isValid,
    rule: 'docRequiredIssuingAuthority',
    helpTextTranslationIndex,
    fields,
  };
}
